import React from "react";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import PlayIdCard from "components/PlayIdCard";
import { isLoggedIn } from "modules/session/selectors";
import { loadMyProfile } from "modules/playground/action";
import { getMyProfile } from "modules/playground/selectors";

function PlayIdPage(props) {
  React.useState(() => {
    if (props.isLoggedIn) {
      props.loadMyProfile();
    }
  }, []);

  const name = props.myProfile ? props.myProfile.name : 0;
  const playId = props.myProfile ? props.myProfile.play_id : 0;
  return <PlayIdCard playerName={name} myId={playId} />;
}

const withConnect = connect(
  state => ({
    myProfile: getMyProfile(state),
    isLoggedIn: isLoggedIn(state)
  }),
  {
    loadMyProfile
  }
);

export default withConnect(PlayIdPage);
